import axiosInstance from "../services/axiosComman";

export const handleKeyDown = (e) => {
    if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {  
      e.preventDefault(); // Prevent form submission on Enter
    }
  };


  export function ScreenOpen({link,id}){
    axiosInstance.put(`/${link}/${id}/screen_open`,{"isOpen":true}).then(res=>{
    }).catch(err=>{
    })
  }
  
  export async function ScreenClose({link,id}){
    await axiosInstance.put(`/${link}/${id}/screen_closed`,{"isClosed":false}).then(res=>{
    }).catch(err=>{
    })
  }
  
  
  
  export function OnDownload(id,name){
    axiosInstance.get(`/export/pdf_download?standard_id=${id}&module_name=${name}`).then(res=>{
    }).catch(err=>{
    })
  }